<template>
  <div ref="loadingContainer">
    <div style="width: 100%">
      <Datatable v-bind="$data" :HeaderSettings="false">
        <div slot="table" v-if="pending"></div>
      </Datatable>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Datatable from 'vue2-datatable-component-mhascak'
// import DatatableLocale from './lib/datatable-local-cs'
import GridComponents from '@components/dataGrid'
import { Promise } from 'bluebird'
import CoreSettingApi from '@api/core/settings'

Vue.use(Datatable)

export default {
  name: 'SettingTable',
  components: { ...GridComponents },
  props: ['row'],
  created() {
    let self = this
    this.xprops.eventbus
      .$on('RELOAD', this.loadData)
      .$on("EDIT_ITEM", payload => {
        console.log(payload);
        this.$swal({
            title: "Úprava hodnoty",
            content: {
              element: "input",
              attributes: {
                value: payload.row.value
              } 
            },
            buttons: ["Zavřít", "Uložit"],
            inputAttributes: {
                maxLength: 255
            },                    
        }).then(result =>
        {   
            console.log(result);
            if (result) {
                CoreSettingApi.updateSetting(payload.row.name, result)
                .then(response => {
                        this.xprops.eventbus.$emit('RELOAD');
                        this.$snotify.success("Hodnota byla úspěšně změněna!");
                                       
                }).catch(e => {
                    console.log(e);
                })
            }
        });
       })
      .$on('DELETE_ITEM', (payload) => {})
  },
  methods: {
    loadData() {
      CoreSettingApi.getSettingGridResult({
        params: {
          pq_filter: JSON.stringify(this.query.filters),
          pq_sort: JSON.stringify(this.query.sort),
          pq_curPage: Math.ceil(+this.query.offset / +this.query.limit) + 1,
          pq_rPP: this.query.limit,
        },
      })
        .then((response) => {
          console.log(response);
          this.data = response.data.result.data ;
          this.total = response.data.result.total;
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.pending = false
        })
    },
  },
  data() {
    return {
      gridName: 'SettingsGrid',
      columns: [
        {
          title: "Akce",
          tdComp: "Actions",
          thStyle: { width: "85px" },
          tdStyle: { width: "85px" },
          fixed: true,
        },
        {
          title: "Název",
          field: "name",
          sortable: true,
          colStyle: { width: "200px" },
          thComp: "FilterTh"
        },
        {
          title: "Hodnota",
          field: "value",
          sortable: true,
          colStyle: { width: "200px" }
        }
      ],
      pending: true,
      data: [],
      selection: [],
      supportBackup: true,
      tblStyle: 'table-layout: fixed', // must
      tblClass: 'table-bordered',
      fixHeaderAndSetBodyMaxHeight: 500,
      fullHeight: {
        enabled: true,
        heightCorrection: -370,
      },
      total: 0,
      query: {},
      xprops: {
        eventbus: new Vue(),
      },
    }
  },
  watch: {
    query: {
      handler() {
        this.loadData()
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.xprops.eventbus.$off()
  }
}
</script>
